module.exports = __webpack_public_path__ + "media/audio30.4c8e6607.mp3";